import React, {Component} from 'react';
import {Breadcrumb, Icon} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import ProductDialog from "../../components/inventories/ProductDialog";
import DynamicTable from "../../components/extras/DynamicTable";

class User extends Component{
    render(){
        return <span>
            {this.props.user.first_name} {this.props.user.last_name}
        </span>
    }
}

class TrackType extends Component{
    render(){
        return <span>
            <Icon style={{'color':this.props.track_type_text.reduce ? '#e44745':'#9ccc65'}} name={this.props.track_type_text.reduce ? 'arrow down':'arrow up'} />
            <span style={{'color': !this.props.track_type_text.is_manual ? '':this.props.track_type_text.reduce ? '#e44745':'#9ccc65'}}>{this.props.track_type_text.text}</span>
        </span>
    }
}

class StockMovementsIngredients extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Evento', 'Producto', 'Inventario Actual', 'Inventario Anterior', 'Diferencia', 'Usuario', 'Fecha'],
                title: 'Movimientos - Ingredientes',
                name: 'Ingrediente',
                has_actions: false,
                pagination: true,
                url: `ingredient-stock-track`,
                values: ['id', 'track_type_text', 'ingredient', 'last_stock_text', 'current_stock_text', 'difference', 'user', 'date'],
                datetime_fields: ['date'],
                child_fields: [{ingredient:'name'}],
                component_fields:[{
                    user: User,
                    track_type_text: TrackType
                }],
                id: 'table_stock'
            },
        };
    }

    render() {

        return (
            <div>
                <Helmet>
                    <title>Ingredientes | Movimientos de Inventario - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Movimientos de Inventario - Ingredientes</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <ProductDialog/>
            </div>
        );
    }
}

export default StockMovementsIngredients;



// WEBPACK FOOTER //
// ./src/containers/inventories/StockMovementsIngredients.js